import { ValidationSchema } from '../../../../../@types/validation-types'
import {
  defaultApiSearchData,
  defaultConnections,
  defaultConstruction,
  defaultCosts,
  defaultDescription,
  defaultHangarBasicInfo,
  defaultHangarOtherFacilities,
  defaultObjectNumbers,
  useManualAndInternationalAddress,
} from '../../../../../services/validation/flow/defaultSchemas'
import { validationRules } from '../../../../../services/validation/rules/validationRules'

export const agentProductionHallRentSchema: ValidationSchema = {
  address: useManualAndInternationalAddress,
  basicInfo: defaultHangarBasicInfo,
  costs: { ...defaultCosts, courtage: validationRules.courtage, courtageNote: validationRules.courtageNote },
  description: defaultDescription,
  otherFacilities: defaultHangarOtherFacilities,
  connections: defaultConnections,
  construction: defaultConstruction,
  objectNumbers: defaultObjectNumbers,
  apiSearchData: defaultApiSearchData,
}
